import { IntegrationConfiguration } from '@/models/product';

export enum BulkUpdateType {
    ACTIVE_STATUS,
    SET_DYNAMIC_PRICING,
    SET_REMOVE_CONDITION,
    SET_BOOKING_OPTIONS,
}

export type ConfigurationState = {
    activeStatus: boolean;
    setDynamicPricing: boolean;
    setRemoveConditions: boolean;
    setBookingOptions: boolean;
};

export const initialConfigurationState = {
    activeStatus: false,
    setDynamicPricing: false,
    setRemoveConditions: false,
    setBookingOptions: false,
};

export type SeTActiveStatusPayload = {
    type: BulkUpdateType.ACTIVE_STATUS;
    isActive: boolean;
};

export type SourceConfiguration = {
    productId: string;
    copyPriceConditions: boolean;
    copyContingentConditions: boolean;
};

export type SetDPPayload = {
    type: BulkUpdateType.SET_DYNAMIC_PRICING;
    sourceConfiguration: SourceConfiguration;
};

export type RemoveConditionConfiguration = {
    removePriceConditions: boolean;
    removeContingentConditions: boolean;
};

export type SetRemoveConditionPayload = {
    type: BulkUpdateType.SET_REMOVE_CONDITION;
    payload: RemoveConditionConfiguration;
};

export type ConfigurationCollection = {
    integrationConfiguration: IntegrationConfiguration;
    mobileConfiguration: IntegrationConfiguration;
    portalConfiguration: IntegrationConfiguration;
    b2bConfiguration: IntegrationConfiguration;
};

export type SetBookingOptionsPayload = {
    type: BulkUpdateType.SET_BOOKING_OPTIONS;
    configurations: ConfigurationCollection;
};

export type BulkUpdateActionPayload =
    | SeTActiveStatusPayload
    | SetDPPayload
    | SetBookingOptionsPayload
    | SetRemoveConditionPayload;
